<template>
    <!--字母键盘-->
    <transition name="page-bottom">

        <div class="brt-mixboard-module" v-show="visible" @click.stop="">

            <div class="close" v-if="hasClose"  @click.stop="visible = false"><i class="iconfont icon-cha"></i></div>

            <div class="board-box" v-if="!twoArr">

                <a v-for="item in keys" @click.stop="selected(item)">{{item}} </a>

                <a v-if="hasClear" class="box" @click.stop="clearV">清空</a>
                <a v-if="hasDel" class="box" @click.stop="deleteV">删除</a>

            </div>

        </div>

    </transition>

</template>

<script>
    export default {
        name: "LetterBoard",
        data(){
            return {
                visible:false,
                twoArr:false,   //二维数组
                hasDel:false,   //删除
                hasClear:false, //清空
                hasClose:false, //关闭
                hasDown:false,  //向下关闭
                keys:[],
            }
        },

        methods:{
            deleteV(){},
            selected(item){},
            clearV(){}
        }
    }
</script>

<style lang="less">

    @import "../../../styles/transition";
    @import "../../../styles/cssBlock";

    .brt-mixboard-module{

        .absoluteByCover();
        top: auto;
        font-size: @fontSizeA4;
        color: @fontColorA1;
        text-align: right;
        pointer-events: none;

        >.close{
            pointer-events: auto;
            display: inline-block;
            width: @standartHeightA1;
            height: @standartHeightA1;
            line-height: @standartHeightA1;
            text-align: center;
            border-radius: @standartHeightA1 0px 0px;
            background-color: @themeReverseColor;
            box-shadow: -1px -0.04rem 0.075rem rgba(51, 51, 51, 0.15);
            padding-left: 0.09rem;
            padding-top: 0.05rem;

            >i{
                font-size: @fontSizeA3;
                vertical-align: middle;
            }

            &:active{
                opacity: .8;
            }
        }

        >.board-box{
            clear: both;
            float: none;
            overflow: hidden;
            background-color: @themeReverseColor;
            box-shadow: @shadowbox;
            pointer-events: auto;
            // border-top: 1px solid @borderColorA2;
            border-left: 1px solid @borderColorA2;
            @var:@90px;
            >a{
                display: inline-block;
                width: 14.28%;
                height: @var;
                line-height: @var;
                float: left;
                text-align: center;
                overflow: hidden;
                border-bottom: 1px solid @borderColorA2;
                border-right: 1px solid @borderColorA2;
                font-weight: bold;
                &:active{
                    background-color: @fontColorB4;
                }

                &.box{
                    width: 35.7%;
                }
            }
        }

    }

</style>
